/* eslint-disable max-len */
export default {
  // 订阅列表
  subscriptionList: {
    title: 'Mon Abonnement',
    subscriptionDetail: 'Détail de l\'abonnement',
    changeAddress: 'Changement d\'adresse',
    productType: 'Type de produit',
    subscriptionStatusList: [
      {
        value: '',
        label: 'Tous',
      },
    ],
    noOrders: 'Aucune commande dans cette catégorie. Parcourir d\'autres cours dispensés par Think Academy.',
    moreCourses: 'Parcourir plus de cours',
    noSubscriptionText: 'Vous n\'avez actuellement aucun abonnement de renouvellement automatique',
    unSubscribeTipsTitle: 'Veuillez contacter votre centre d\'apprentissage pour annuler l\'abonnement',
    unSubscribeTipsContent: 'Après l\'annulation de l\'abonnement, il n\'y aura pas de frais pour le mois suivant. Les commandes existantes n\'affecteront pas les cours en cours.',
    autoRenewal: 'Renouvellement automatique',
    openRecords: 'Enregistrements d\'activation',
    learnPlayTag: 'Math',
    every: 'Chaque',
    timeLimit: 'Période',
    month: 'mois',
    phase: 'Phase',
    stage: 'Étape {num}',
    deductionDate: 'Date de déduction',
    deductionAmount: 'Montant de la déduction',
    status: 'Statut',
    statusText: {
      1: 'À payer',
      2: 'Payé',
      3: 'Échec de paiement',
    },
    unsubscribe: 'Se désabonner',
    weekMap: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    weekMapFull: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    weekDayList: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    monthsList: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    monthsListFull: [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December',
    ],
    curriculumSchedule: 'Curriculum schedule',
    today: 'today',
    classBegun: 'started',
    unClassBegun: 'not started',
    noClasses: 'No classes today',
    activedTip: 'Click the check box to activated',
  },
  subscriptionCard: {
    pay: 'Payer',
    unsuceess: 'Unsuceessful Deduction',
    viewOrder: 'Voir la commande',
    start: 'Heure de début',
    end: 'End Time',
    nextPay: 'Prochain paiement estimé',
    expire: 'Heure d\'expiration',
    expireDate: 'Date d\'expiration',
    orderTime: 'Heure de la commande',
    statusText: {
      1: 'À payer',
      2: 'Actif',
      3: 'Actif',
      4: 'Annulé',
    },
    paymentMethod: 'Méthode de paiement',
    pos: 'Installment Payment via POS',
    card: 'Carte',
    MakeupPayment: 'Paiement complémentaire',
  },
  subscriptionDetail: {
    cancel: 'Annuler l\'abonnement',
    cancelReasons: 'Raisons de l\'annulation',
    title: 'Détail de l\'abonnement',
  },
  // 支付失败结果页提示文案
  toBePaidResult: {
    title: 'Rappel de paiement important',
    content: 'Si vous avez été débité, mais la commande n\'est pas dans le statut \'payé, cela peut être dû au fait que nous n\'avons pas encore reçu la notification de déduction de la banque. Veuillez vérifier plus tard. Si vous avez des questions, veuillez nous contacter à:',
    confirm: 'J\'ai compris!',
  },
  personalInfo: {
    childEdit: 'Profil de l\'enfant',
    phone: 'Numéro',
    emailAddress: 'E-mail',
    manage: 'Gérer les informations de mes enfants et mes informations personnelles',
    manageChild: 'Gérer mes enfants',
    edit: 'Modifier mon profil',
  },
  childFilter: {
    child: 'Enfant',
    type: 'Type',
    kids: 'Enfants',
    save: 'Enregistrer',
  },
  address: {
    noAddress: 'Vous n\'avez pas encore ajouté d\'adresse',
  },
  coupon: {
    title: 'Mes coupons',
    detail: 'Détails des coupons',
    recommendClass: 'Cours recommandés',
    testResult: 'Comprendre le résultat du test',
    on: 'en {feeName}',
    over: 'plus {symbol}{price}',
    off: '%Off',
    offThousand: '‰Off',
    noAvailable: 'Aucun cours disponible ne peut être appliqué au coupon choisi.',
    redeemFailedTips: 'Le code de réduction n\'existe pas, veuillez réessayer.',
    redeemFailedCodeText: {
      4003: 'Désolé, cette activité est terminée',
      7003: 'Désolé, cette activité est réservée aux nouveaux étudiants',
      7004: 'Vous avez déjà participé à cette activité',
      7005: 'Vous avez déjà participé à cette activité',
    },
  },
  courses: {
    title: 'cours',
    availableClass: 'Cours disponibles',
    noCoursesTip: 'Aucun cours dans cette catégorie. Parcourez plus de cours proposés par Think Academy.',
    moreCourses: 'Parcourir plus de cours',
  },
  tips: {
    editSuccess: 'Élève modifié avec succès',
    copyFiled: 'Copie échouée',
    copySuccess: 'Copie Succès',
    success: 'Succès',
    redeemSuccess: 'Échange réussi',
    addSuccess: 'Élève ajouté avec succès',
    login: 'Veuillez vous reconnecter',
    loginTips: 'Votre session de connexion a expiré. Veuillez vous reconnecter pour continuer.',
    cancel: 'Annuler',
    loginAgain: 'Se connecter à nouveau',
    invalid: 'Cette saisie est requise',
    removeWish: 'Retiré de la liste de souhaits',
    loading: 'Chargement...',
    deleteSuccess: 'Suppression réussie',
    addSuccessful: 'Ajout réussi',
    updateSuccess: 'Mise à jour réussie',
    updateFailed: 'Échec de la mise à jour. Identique à l\'adresse précédente.',
    viewCourses: 'Voir cours',
    emptyTips: 'Les cours disponibles arrivent bientôt ! Consultez les cours actuellement disponibles proposés par Think Academy',
    before: 'Avant',
    after: 'Après',
  },
  coursesCardTag: {
    new: 'Nouveau',
    popular: 'Populaire',
    full: 'Complet',
    current: 'Actuel',
    completed: 'Achevé',
    refunded: 'Remboursé',
    playBack: 'Playlack uniquement',
  },
  getNotifiedConfig: {
    title: 'Vous ne trouvez pas de cours approprié pour votre enfant?',
    description: 'Ce n\'est pas grave! Pendant que vous prenez le temps de réfléchir, laissez-nous votre adresse e-mail pour recevoir un soutien aux admissions pour la grammaire et l\'entrée dans les écoles indépendantes, des liens vers des webinaires 11+ et plus de matériel de pratique.',
    form: {
      grade: 'Niveau scolaire de l\'enfant',
      firstName: 'Prénom de l\'enfant',
      lastName: 'Nom de famille',
      email: 'Votre adresse e-mail',
      platform: 'Comment avez-vous entendu parler de nous?',
    },
    notice: 'Inscrivez-vous à notre liste de diffusion pour recevoir les dernières nouvelles, promotions et mises à jour! ',
    errorNotice: 'Échec de la soumission. Veuillez réessayer ultérieurement.',
    emailError: 'L\'adresse e-mail semble invalide.',
    phoneError: 'Le numéro de téléphone semble invalide.',
    submit: 'Soumettre',
    success: 'Merci de votre intérêt pour Think Academy!',
  },
  // Cookies声明
  cookiesStatement: {
    description: 'Nous utilisons des cookies pour vous fournir de meilleurs services. En cliquant sur n\'importe quel lien de cette page, vous donnez votre consentement.',
  },
  // cookies policy
  cookiesAccept: {
    title: 'Notre utilisation des cookies',
    description: `<p>Nous utilisons des cookies pour personnaliser votre expérience utilisateur sur notre site web.</p>
    <p>Pour plus d'informations, veuillez consulter notre <a href="/cookies-policy" target="_blank">Politique en matière de cookies</a></p>`,
    accept: 'Accepter',
    reject: 'Rejeter',
  },
  unpaidCourses: {
    tips1: `
      <p class="dotted-para" style="margin-left: 10px; margin-bottom: 10px;">En raison de la forte demande pour les cours, il y a une date limite pour changer de classe.
       Sélectionnez le cours que vous souhaitez entre :  <span style="color: #3e6eff;">{startTime} - {endTime}</span></p>`,
    tips2: `
      <p class="dotted-para" style="margin-left: 10px; margin-bottom: 10px;">En raison de la forte demande pour les cours, il y a une date limite pour changer de classe. 
      Sélectionnez le cours que vous souhaitez après :   <span style="color: #3e6eff;">{startTime}</span></p>`,
    tips3: `
      <p class="dotted-para" style="margin-left: 10px; margin-bottom: 10px;">En raison de la forte demande pour les cours, il y a une date limite pour changer de classe.
       Sélectionnez le cours que vous souhaitez avant la date limite : <span style="color: #3e6eff;">{endTime}</span></p>`,
  },
  triageDesk: {
    selectChildForEvaluation: "Veuillez sélectionner l'enfant à évaluer :",
    evaluateAnotherChild: 'Évaluer un autre enfant',
    previousStep: 'Étape précédente',
    nextStep: 'Étape suivante',
    provideContactInfoForResults: "Veuillez fournir vos coordonnées pour obtenir les résultats de l'évaluation :",
    childName: 'Le nom de votre enfant',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    providePhoneNumber: 'Veuillez fournir votre numéro de téléphone',
    phoneNumber: 'Numéro de téléphone',
    provideEmailAddress: 'Veuillez fournir votre adresse e-mail',
    emailAddress: 'Adresse e-mail',
    enterValidPhoneNumber: 'Veuillez entrer un numéro de téléphone valide',
    enterValidEmailAddress: 'Veuillez entrer une adresse e-mail valide',
    provideContactInfoForMaterials: "Veuillez fournir vos coordonnées pour accéder aux supports d'apprentissage :",
    submit: 'Soumettre',
    submissionSuccessDownload: "Soumission réussie ! Cliquez pour télécharger vos supports d'apprentissage !",
    downloadingAutoClickButton: 'Téléchargement automatique... Si cela ne commence pas, cliquez sur le bouton ci-dessous pour télécharger.',
    download: 'Télécharger',
    selectEvaluationMethod: "Veuillez sélectionner votre méthode d'évaluation préférée :",
    onlineEvaluation: 'Évaluation en ligne',
    completeOnlineAssessment: "Complétez l'évaluation en ligne, et nos enseignants professionnels vous contacteront pour analyser les résultats.",
    evaluationViaZoom: 'Évaluation via Zoom',
    scheduleProfessionalTeacher: 'Planifiez un enseignant professionnel pour effectuer une évaluation individuelle pour votre enfant.',
    evaluateInLearningCenter: "Évaluer dans le centre d'apprentissage",
    scheduleVisitCupertino: 'Réservez une visite au {campus}, nos enseignants professionnels effectueront une évaluation individuelle pour votre enfant.',
    evaluationScheduledSuccess: 'Votre évaluation a été planifiée avec succès !',
    scheduleSentEmail: 'Votre emploi du temps sera envoyé à votre adresse e-mail : {emailAddress}',
    scheduleInformation: 'Informations sur le programme',
    childNameLabel: "Nom de l'enfant :",
    gradeLabel: 'Niveau :',
    dateLabel: 'Date :',
    timeLabel: 'Temps :',
    yourPhoneNumberLabel: 'Votre numéro de téléphone :',
    yourEmailAddressLabel: 'Votre adresse e-mail :',
    zoomLinkLabel: 'Lien Zoom :',
    locationLabel: 'Lieu :',
    addressLabel: 'Adresse :',
    contactUsLabel: 'Contactez-nous :',
    workingHoursLabel: 'Heures de travail :',
    scheduleAssessment: 'Veuillez planifier votre évaluation :',
    noSuitableTimeContactUs: [
      'Pas de moment approprié ? ',
      'Rechoisissez la méthode d\'évaluation',
      ' ou contactez-nous : Appelez le <span class="color">{phoneNumber}</span> ou envoyez un e-mail à <span class="color">{emailAddress}</span>.',
    ],
    selectPreferredTime: 'Veuillez sélectionner votre heure préférée :',
    contactUsInfo: 'Pas de moment convenable ? Appelez-nous au <span class="color">{phoneNumber}</span> ou envoyez un email à <span class="color">{emailAddress}</span>.',
    dateHeader: 'Date',
    timeHeader: 'Temps',
    slotsHeader: 'emplacements',
    fiveLeft: 'Il reste {num}',
    fullClass: 'Classe complète',
    lessons: 'Leçons',
    signUp: "S'inscrire",
    switchToCupertinoQuestions: 'Passage à {campus}, nous allons vous poser quelques questions à nouveau.',
    confirm: 'Confirmer',
    cancel: 'Annuler',
    maxStudentAccountsLimit: "Vous pouvez ajouter jusqu'à 6 comptes d'élèves. Veuillez sélectionner à nouveau les élèves existants.",
    loading: 'Chargement en cours...',
    loadingFailed: 'Échec du chargement, veuillez réessayer plus tard.',
    retry: 'Réessayer',
  },
}
